// Modernized Assign Provider Dialog (React + MUI)

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Avatar,
  Grid,
  Tooltip,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const AssignProviderDialog = ({
  open,
  onClose,
  providers,
  selectedProviderId,
  setSelectedProviderId,
  selectedRequest,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle sx={{ fontWeight: 600, fontSize: 22, pb: 0 }}>
        Assign Provider
      </DialogTitle>
      <DialogContent sx={{ mt: 1 }}>
        {providers.length === 0 ? (
          <Typography>No providers available for this service type.</Typography>
        ) : (
          <Grid container spacing={2}>
            {providers.map((p) => {
              const isBusy = p.isBusy;
              const isAssigned = selectedRequest?.assignedProviderId === p.id;
              const isSelected = selectedProviderId === p.id;

              return (
                <Grid item xs={12} key={p.id}>
                  <Box
                    onClick={() => {
                      if (!isBusy && !isAssigned) setSelectedProviderId(p.id);
                    }}
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      border: `2px solid ${
                        isSelected ? "#2196f3" : "#e0e0e0"
                      }`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      cursor: isBusy || isAssigned ? "not-allowed" : "pointer",
                    }}
                  >
                    <Box display="flex" alignItems="center" gap={2}>
                      <Avatar src={p.avatarUrl} />
                      <Box>
                        <Typography fontWeight={600}>{p.username}</Typography>
                        <Typography variant="body2" color="text.secondary">
                          {isAssigned
                            ? "Already Assigned"
                            : isBusy
                            ? `Busy (${p.ongoingRequestStatus})`
                            : "Available"}
                        </Typography>
                      </Box>
                    </Box>
                    {isAssigned ? (
                      <Tooltip title="Already assigned to this request">
                        <WarningAmberIcon color="warning" />
                      </Tooltip>
                    ) : isBusy ? (
                      <Tooltip title={`Currently handling: ${p.ongoingRequestStatus}`}>
                        <WarningAmberIcon color="error" />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Ready to assign">
                        <CheckCircleIcon color="success" />
                      </Tooltip>
                    )}
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={
            !selectedProviderId ||
            selectedProviderId === selectedRequest?.assignedProviderId ||
            providers.find((p) => p.id === selectedProviderId)?.isBusy
          }
        >
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignProviderDialog;
